import "./ToggleSwitch.scss";

type ToggleSwitchProps = {
  checked: boolean;
  disabled?: boolean;
  id: string;
  label?: string;
  name: string;
  onChange: () => void;
};

export const ToggleSwitch = ({ id, label, name, checked, onChange, disabled }: ToggleSwitchProps) => {
  return (
    <div>
      <div className={"toggle-switch"}>
        <input
          type="checkbox"
          name={name}
          className="checkbox"
          id={id}
          checked={checked}
          aria-checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className="label" tabIndex={disabled ? -1 : 1} htmlFor={id}>
          <span className={disabled ? "inner disabled" : "inner"} tabIndex={-1} />
          <span className={disabled ? "switch disabled" : "switch"} tabIndex={-1} />
        </label>
      </div>
      <span className="text">{label}</span>
    </div>
  );
};
